import { OrderMethod } from '../../../../../services/exports/Constants';

export default {
  [OrderMethod.Pickup]: 'Nouto',
  [OrderMethod.Delivery]: 'Toimitus',
  [OrderMethod.OnSite]: 'Paikan päällä',
};
